<template>
  <v-container>
    <div v-if="loading" class="text-center my-5">
      <v-progress-circular
        indeterminate
        color="primary"
        size="48"
      ></v-progress-circular>
      <p class="mt-3">Loading Data...</p>
    </div>
    <div v-else>
      <v-expansion-panels>
        <!-- Loop Through Programs -->
        <v-expansion-panel v-for="program in programs" :key="program.id">
          <v-expansion-panel-header>
            <div class="d-flex flex-wrap align-center">
              <v-chip small color="primary" text-color="white">
                {{ program.programType }}
              </v-chip>
              <div class="ml-3 text-truncate" style="max-width: 50%">
                <span class="font-weight-bold">{{ program.programName }}</span>
                <span class="grey--text">({{ program.programId }})</span>
                <span class="font-weight-bold">{{
                  program.private == 1 ? "(Private)" : "(Public)"
                }}</span>
                <v-divider vertical class="mx-2"></v-divider>
                <span class="grey--text">
                  <v-icon>fitness_center</v-icon>
                  {{ program.workouts.edges.length }}
                </span>
              </div>
              <v-spacer></v-spacer>
              <span class="font-weight-bold">{{
                "Club: " + program.club.clubName
              }}</span>
              <v-spacer></v-spacer>
              <div class="ml-3 text-truncate" style="max-width: 50%">
                <span class="font-weight-bold">{{
                  program.programShortDesc
                }}</span>
                <span class="grey--text">
                  {{
                    program.duration ? "Term: (" + program.duration + ")" : null
                  }}</span
                >
              </div>
              <v-spacer></v-spacer>
              <div class="d-none d-sm-flex">
                <v-chip outlined small v-if="program.startDate">
                  {{
                    program.startDate
                      ? "Start: " + program.startDate.split("T")[0]
                      : null
                  }}
                </v-chip>
                <v-chip outlined small v-if="program.endDate">
                  {{
                    program.endDate
                      ? "End: " + program.endDate.split("T")[0]
                      : null
                  }}
                </v-chip>
              </div>
              <!-- Program Actions -->
              <v-menu offset-y open-on-hover>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon color="primary" dark v-bind="attrs" v-on="on">
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="openDialog('add', 'program')">
                    <v-list-item-icon>
                      <v-icon color="green">add</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Add Program</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="openDialog('edit', 'program', program)">
                    <v-list-item-icon>
                      <v-icon color="blue">edit</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Edit Program</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="openDialog('delete', 'program', program)"
                  >
                    <v-list-item-icon>
                      <v-icon color="red">delete</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Delete Program</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="openDialog('add', 'workout', program)">
                    <v-list-item-icon>
                      <v-icon color="green">add</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Add Workout</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="program-details">
              <!-- <h3 class="program-title">Program Details</h3> -->
              <ul class="program-list">
                <li class="program-columns">
                  <div class="program-column">
                    <strong>Program Description:</strong>
                    <span class="program-description">{{
                      program.programDesc
                    }}</span>
                  </div>
                  <div class="program-column">
                    <strong>Goals:</strong>
                    <span class="program-goals">{{ program.goals }}</span>
                  </div>
                </li>
                <li class="program-columns">
                  <div class="program-column">
                    <strong>Structure:</strong>
                    <span class="program-focus">{{ program.structure }}</span>
                  </div>
                  <div class="program-column">
                    <strong>Skills Focus:</strong>
                    <span class="program-focus">{{ program.focus }}</span>
                  </div>
                </li>
              </ul>
            </div>

            <!-- Loop Through Workouts -->
            <v-expansion-panels>
              <v-expansion-panel
                v-for="workout in program.workouts.edges"
                :key="workout.node.id"
              >
                <v-expansion-panel-header>
                  <div class="workout-header">
                    <span
                      ><v-icon>timer</v-icon> {{ workout.node.workoutId }}</span
                    >
                    <v-divider vertical class="mx-2"></v-divider>
                    <span
                      ><v-icon>description</v-icon>
                      {{ workout.node.workoutDesc }}</span
                    >
                    <v-divider vertical class="mx-2"></v-divider>
                    <span
                      v-if="
                        !workout.node.dayOfMicrocycle &&
                        workout.node.dayOfMicrocycle != 0
                      "
                      ><strong>Day:</strong>
                      {{ workout.node.dayOfMicrocycle }}</span
                    >
                    <v-divider
                      v-if="
                        !workout.node.dayOfMicrocycle &&
                        workout.node.dayOfMicrocycle != 0
                      "
                      vertical
                      class="mx-2"
                    ></v-divider>
                    <span
                      v-if="
                        !workout.node.duration && workout.node.duration != 0
                      "
                      ><v-icon>access_time</v-icon>
                      {{ workout.node.duration }} min</span
                    >
                    <v-divider
                      v-if="
                        !workout.node.duration && workout.node.duration != 0
                      "
                      vertical
                      class="mx-2"
                    ></v-divider>
                    <span
                      v-if="!workout.node.volume && workout.node.volume != 0"
                    >
                      <v-icon>water_drop</v-icon>
                      {{ workout.node.volume }}m</span
                    >
                    <v-divider
                      v-if="!workout.node.volume && workout.node.volume != 0"
                      vertical
                      class="mx-2"
                    ></v-divider>
                    <span class="grey--text">
                      <v-icon>whatshot</v-icon>
                      {{ workout.node.sets.edges.length }}
                    </span>
                    <v-divider vertical class="mx-2"></v-divider>
                    <span v-if="workout.node.videoUrl" class="grey--text">
                      <v-icon
                        color="blue"
                        @click="openVideo(workout.node.videoUrl)"
                      >
                        play_circle
                      </v-icon>
                    </span>
                    <v-divider vertical class="mx-2"></v-divider>

                    <!-- Workout Actions -->
                    <v-menu offset-y open-on-hover>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon color="primary" v-bind="attrs" v-on="on">
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          @click="openDialog('add', 'workout', program)"
                        >
                          <v-list-item-icon>
                            <v-icon color="green">add</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Add Workout</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click="openDialog('edit', 'workout', workout.node)"
                        >
                          <v-list-item-icon>
                            <v-icon color="blue">edit</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Edit Workout</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click="openDialog('delete', 'workout', workout.node)"
                        >
                          <v-list-item-icon>
                            <v-icon color="red">delete</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Delete Workout</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <!-- <p>{{ workout.node.workoutDesc }}</p> -->
                  <SetsTable
                    :sets="
                      workout.node &&
                      workout.node.sets &&
                      workout.node.sets.edges
                        ? workout.node.sets.edges.map((set) => set.node)
                        : []
                    "
                    :loading="loading"
                    @update-sets="updateSets"
                    @add-set="openDialog('add', 'set', workout.node, $event)"
                    @edit-set="openDialog('edit', 'set', $event)"
                    @delete-set="openDialog('delete', 'set', $event)"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <!-- Dialog -->
    <v-dialog v-model="dialog.open" persistent max-width="90%">
      <v-card>
        <v-card-title class="headline">{{ dialog.title }}</v-card-title>
        <v-card-text>
          <p v-if="dialog.mode === 'delete'">
            Are you sure you want to delete this {{ dialog.targetType }}?
          </p>
          <div v-else-if="dialog.mode === 'edit' || dialog.mode === 'add'">
            <v-container>
              <v-row dense>
                <v-col
                  cols="12"
                  sm="6"
                  v-for="(value, key) in filteredTarget"
                  :key="key"
                  :hidden="hiddenFields.includes(key)"
                >
                  <!-- Check the type and render the appropriate component -->
                  <v-textarea
                    v-if="textareaFields.includes(key)"
                    :label="key"
                    v-model="dialog.target[key]"
                    rows="1"
                  ></v-textarea>

                  <v-switch
                    v-else-if="booleanFields.includes(key)"
                    :label="key"
                    v-model="dialog.target[key]"
                  ></v-switch>
                  <v-text-field
                    v-else-if="numberFields.includes(key)"
                    :label="key"
                    v-model="dialog.target[key]"
                    hide-details
                    single-line
                    type="number"
                  />
                  <v-text-field
                    v-else
                    :label="key"
                    v-model="dialog.target[key]"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="red" @click="closeDialog">Cancel</v-btn>
          <v-btn
            text
            color="green"
            @click="handleDialogAction(dialog.mode, dialog.targetType)"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <VideoDialog
      v-if="videoUrl"
      :videoUrl="videoUrl"
      @close="videoUrl = null"
    />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import SetsTable from "./sets_table.vue";
import VideoDialog from "@/components/shared/video_dialog.vue"; // Import the new component

export default {
  components: { SetsTable, VideoDialog },
  data() {
    return {
      programs: [],
      loading: true,
      hiddenFields:
        "updateSource,clubId,workoutId,setId,order,programId,parentProgramId",
      textareaFields: "programDesc,goals,workoutDesc,setDesc",
      booleanFields: "private,isLibrarySet",
      numberFields: "noOfSets,duration,noOfReps,dayOfMicrocycle,volume",
      videoUrl: null,
      sets: [],
      dialog: {
        open: false,
        title: "",
        mode: "",
        targetType: "",
        target: null,
      },
    };
  },
  async created() {
    try {
      await this.$store.dispatch("allProgram", {
        clubId: 16,
      });
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  },
  computed: {
    ...mapGetters(["programList", "user"]),
    setsList() {
      if (
        this.workout &&
        this.workout.node &&
        this.workout.node.sets &&
        this.workout.node.sets.edges
      ) {
        return this.workout.node.sets.edges.map((set) => set.node);
      }
      return [];
    },
    filteredTarget() {
      // Filter out unwanted keys
      //console.log(this.dialog.target);
      if (this.dialog.targetType == "program") {
        this.dialog.target.clubId = this.$store.getters.club;
      }
      this.dialog.target.updateSource = this.user.userName;
      return Object.keys(this.dialog.target)
        .filter(
          (key) =>
            !["id", "workouts", "__typename", "sets", "club"].includes(key)
        )
        .reduce((result, key) => {
          result[key] = this.dialog.target[key];
          return result;
        }, {});
    },
  },
  methods: {
    openVideo(videoUrl) {
      this.videoUrl = videoUrl;
    },
    // getComponentType(field) {
    //   const fieldTypeMap = {
    //     description: "v-textarea",
    //     isActive: "v-switch",
    //     name: "v-text-field",
    //     // Add more field mappings as needed
    //   };

    //   return fieldTypeMap[field] || "v-text-field"; // Default to v-text-field
    // },
    // getFieldProps(field) {
    //   const type = this.fieldTypes[field];
    //   if (type === "switch") {
    //     return { inset: true }; // Example prop for switch
    //   }
    //   return {};
    // },
    openDialog(mode, targetType, target = null, source = null) {
      this.dialog.open = true;
      this.dialog.mode = mode;
      this.dialog.targetType = targetType;
      // console.log(target);
      if (mode === "add" && targetType === "program") {
        this.dialog.target = {
          programName: "",
          programType: "",
          startDate: "",
          endDate: "",
          programDesc: "",
          programShortDesc: "",
          focus: "",
          goals: "",
          structure: "",
          duration: "",
          clubId: 0,
          private: 1,
        };
      } else if (mode === "add" && targetType === "workout") {
        this.dialog.target = {
          workoutDesc: "",
          duration: 0,
          volume: 0,
          dayOfMicrocycle: 0,
          videoUrl: "",
          programId: target.programId,
        };
      } else if (mode === "add" && targetType === "set") {
        //console.log(target);
        source.workoutId = target.workoutId;
        //console.log(source);
        this.dialog.target = source;
        // {
        //   setName: source,
        //   setDesc: "",
        //   noOfRep: 0,
        //   noOfSets: 0,
        //   setPurpose: "",
        //   distance: 0,
        //   distanceSum: 0,
        //   stroke: "",
        //   tag: "",
        //   workoutId: target.workoutId,
        //   setInterval: 0,
        //   timePerDist: 0,
        //   timeTotal: 0,
        //   equipment: "",
        //   isLibrarySet: false,
        // };
      } else {
        console.log(target);
        this.dialog.target = target;
      }
      this.dialog.title =
        mode === "add"
          ? `Add New ${targetType}`
          : mode === "edit"
          ? `Edit ${targetType}`
          : `Delete ${targetType}`;
    },
    closeDialog() {
      this.dialog.open = false;
      this.dialog.mode = "";
      this.dialog.targetType = "";
      this.dialog.target = null;
    },
    handleDialogAction(mode, targetType) {
      // console.log(mode);
      // console.log(targetType);
      if (targetType === "program") {
        if (mode === "add" || mode === "edit") {
          //this.mutateProgram(this.dialog.target);
          // console.log("test");
          this.mutateProgram(this.filteredTarget);
        } else if (mode === "delete") {
          this.deleteProgram(this.dialog.target.programId);
        }
      } else if (targetType === "workout") {
        if (mode === "add" || mode === "edit") {
          this.mutateWorkout(this.filteredTarget);
        } else if (mode === "delete") {
          this.deleteWorkout(this.dialog.target.workoutId);
        }
      } else if (targetType === "set") {
        if (mode === "add" || mode === "edit") {
          this.mutateSet(this.filteredTarget);
        } else if (mode === "delete") {
          this.deleteSet(this.dialog.target.setId);
        }
      }
      this.closeDialog();
    }, // Program actions
    mutateProgram(program) {
      console.log("Add/Update Program clicked", program);
      program.startDate = null;
      program.endDate = null;
      this.$store.dispatch("programMerge", {
        programData: program,
      });
    },
    deleteProgram(programId) {
      console.log("Delete Program ID:", programId);
      this.$store.dispatch("programDelete", {
        programId: programId,
      });
      //      this.editedItem = {};
    },

    // Workout actions
    mutateWorkout(workout) {
      console.log("Add Workout to Program ID:", workout);
      this.$store.dispatch("workoutMerge", {
        workoutData: workout,
      });
    },
    deleteWorkout(workoutId) {
      console.log("Delete Workout ID:", workoutId);
      this.$store.dispatch("workoutDelete", {
        workoutId: workoutId,
      });
    },

    // Set actions
    mutateSet(set) {
      console.log("Add Set to Workout ID:", set);
      this.$store.dispatch("setMerge", {
        input: set,
      });
    },
    deleteSet(setId) {
      console.log("Delete Set ID:", setId);
      this.$store.dispatch("setDelete", {
        setId: setId,
      });
    },
    updateSets(updatedSets) {
      this.sets = updatedSets;
      const newSetWithOrder = updatedSets.map(({ __typename, ...rest }) => ({
        ...rest,
        updateSource: this.user.userName,
      }));
      // const newSetWithOrder = updatedSets.map((item) => ({
      //   ...item,
      //   updateSource: this.user.userName,
      // }));
      console.log(newSetWithOrder);
      newSetWithOrder.forEach((set) => this.mutateSet(set));
    },
  },
  watch: {
    programList: {
      immediate: true,
      handler(newVal) {
        console.log("programList newVal:", newVal); // Debugging output
        if (
          newVal &&
          newVal.edges &&
          Array.isArray(newVal.edges) &&
          newVal.edges.length > 0
        ) {
          this.programs = newVal.edges.map((edge) => edge.node);
        } else {
          this.programs = [];
          console.log(
            "No valid programs found, setting this.programs to empty array."
          );
        }
      },
    },
  },

  // methods: {
  //   openDialog(action, type, data = null) {
  //     // Implement dialog logic for add, edit, and delete
  //     console.log(`Action: ${action}, Type: ${type}`, data);
  //   },
  // },
};
</script>

<style scoped>
/* Adjust spacing for smaller screens */
.program-header,
.workout-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.program-title {
  font-size: 1rem;
  font-weight: bold;
}

@media (max-width: 600px) {
  .program-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .program-title,
  .program-id {
    font-size: 0.9rem;
  }
}

.program-details {
  max-width: 100%;
  /* Utilize full width */
  margin: 0 auto;
  padding: 1rem;
}

.program-title {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.program-list {
  list-style: none;
  padding: 0;
}

.program-list li {
  margin-bottom: 1rem;
}

.program-columns {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
}

.program-column {
  flex: 1;
}

.program-description,
.program-focus,
.program-goals {
  display: block;
  margin-top: 0.5rem;
}
</style>